import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './Navbar';
import SideDrawer from './SideDrawer';
import FloatingMenu from './FloatingMenu';
import Home from './pages/Home';
import Problem from './pages/Problem';
import Solution from './pages/Solution';
import Features from './pages/Features';
import TechDeepDive from './pages/TechDeepDive';
import Gallery from './pages/Gallery';
import ChallengesNext from './pages/ChallengesNext';
import About from './pages/About';
import './styles/App.css';
import '../index.css';

const App = () => {
  const [drawerOpen, setDrawerOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setDrawerOpen(!drawerOpen);
  };

  return (
    <Router>
      <Navbar onMenuClick={handleDrawerToggle} />
      <SideDrawer open={drawerOpen} onClose={handleDrawerToggle} />
      <FloatingMenu />
      <main className="app-main">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/problem" element={<Problem />} />
          <Route path="/solution" element={<Solution />} />
          <Route path="/features" element={<Features />} />
          <Route path="/tech" element={<TechDeepDive />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/challenges" element={<ChallengesNext />} />
          <Route path="/about" element={<About />} />
        </Routes>
      </main>
    </Router>
  );
};

export default App;
